import React, { useEffect } from "react";
import HelmetMetaTag from "../Components/HelmetMetaTag";
import EventStaffingHero from "./EventStaffingHero";
import EventStaffingAboutClient from "./EventStaffingAboutClient";
import EventStaffingKeyFeatures from "./EventStaffingKeyFeatures";
import EventStaffingMoreFeatures from "./EventStaffingMoreFeatures";
import EventStaffingCta from "./EventStaffingCta";
import EventStaffingTechStack from "./EventStaffingTechStack";
import EventStaffingTestimonial from "./EventStaffingTestimonial";
import "../../Css/EventStaffing.css";

export default function EventStaffingDashboard() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const pageUrl =
    "https://sprigstack.com/portfolio/online-staffing-platform-for-events-and-entertainment-industry";

  return (
    <div className="es-page-container">
      <HelmetMetaTag
        titleName="Custom Event Staffing Platform Development | SprigStack"
        desc="Learn how SprigStack built a custom event staffing platform for Casino Parties to manage dealer bookings, schedules, communication, reporting & approvals."
        canonical={pageUrl}
        ogtitle="Custom Event Staffing Platform Development | SprigStack"
        ogdesc="Learn how SprigStack built a custom event staffing platform for Casino Parties to manage dealer bookings, schedules, communication, reporting & approvals."
        ogtype="website"
        ogurl={pageUrl}
        ogimg="https://sprigstack.com/images/event-staffing/event-staffing-hero-img.png"
      />

      {/* 1st image: Hero section */}
      <EventStaffingHero />

      {/* 2nd image: About client, Requirements, Challenges, SprigStack Solution */}
      <EventStaffingAboutClient />

      {/* Technical Specifications / Tech Stack */}
      <EventStaffingTechStack />

      {/* 3rd image: Key Features */}
      <EventStaffingKeyFeatures />

      {/* 4th image: More Features */}
      <EventStaffingMoreFeatures />

      {/* Contact Redirection CTA */}
      <EventStaffingCta />

      {/* Client Testimonial / Quote Section */}
      <EventStaffingTestimonial />
    </div>
  );
}
